import { render, staticRenderFns } from "./Kab.old.vue?vue&type=template&id=2fdfa63c"
import script from "./Kab.old.vue?vue&type=script&lang=js"
export * from "./Kab.old.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports